import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const Duration = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.caption)};
  margin-left: ${({ theme }) => theme.spacing(2)};

  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const Interactions = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1.5)};
`;

export const Divider = styled.div`
  width: 1px;
  height: 1.6rem;
  background-color: ${({ theme }) => theme.palette.grey[400]};
  align-self: center;
  margin: 0 4px;
`;
